import { createFileRoute } from '@tanstack/react-router'
import { ForbiddenPage } from '@/pages/forbidden/ui/ForbiddenPage'

export const Route = createFileRoute('/forbidden')({
  component: ForbiddenPage,
})
